class Rent{
	constructor() {

		const $buttons = document.querySelectorAll('.open-modal-rent');
		const $modal = document.querySelector('#modalRent');

		$buttons.forEach($btn => {
			$btn.addEventListener('click', e => {
				e.preventDefault();

				if(!this.modal) {
					this.modal = new bootstrap.Modal($modal, {
						keyboard: false
					});

					$modal.querySelector('.modal-body').insertAdjacentHTML("afterbegin", `
					 	<iframe src="/location"></iframe>
					`);
				} else {
					const $iframe = $modal.querySelector('iframe');
					$iframe.src = '/location';
				}

				this.modal.show();
			});
		});
	}
}